import cc from 'classcat';
import { Switch } from '@mui/material';
import { FormikProps } from 'formik';

type MaterialUISwitchColorType = 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'default' | undefined;
type MaterialUISwitchSizeType = 'small' | 'medium' | undefined;

interface ICustomSwitchFormik<T> {
    id: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    color?: MaterialUISwitchColorType;
    className?: string;
    disabled?: boolean;
    size?: MaterialUISwitchSizeType;
    labelText: string;
    hasInfo?: boolean;
    tooltipInfoText?: string;
    context: FormikProps<T>;
    tooltipStyle?: string;
}

export const CustomSwitchFormik = <T extends object>({
    id,
    checked,
    onChange,
    color,
    className,
    size,
    labelText,
    hasInfo,
    tooltipInfoText,
    context,
    disabled = false,
    tooltipStyle,
}: ICustomSwitchFormik<T>) => {
    const { setFieldValue } = context;

    const handleSwitchChange = () => {
        const newChecked = !checked;
        setFieldValue(id, newChecked);
        onChange(newChecked);
    };

    return (
        <div className={cc(['switch', className])}>
            <div className="switch__label">
                <p className="paragraph-3">{labelText}</p>
                {hasInfo && (
                    <div className="switch__label-info-wrapper">
                        <img className="switch__label-info-wrapper--icon" src="/svg/slider/info-icon.svg" alt="info" />
                        <p className={cc([`paragraph-5 switch__label-info-wrapper--tooltip ${tooltipStyle}`])}>{tooltipInfoText}</p>
                    </div>
                )}
            </div>
            <Switch id={id as string} checked={checked} onChange={handleSwitchChange} color={color} disabled={disabled} size={size} />
        </div>
    );
};
